






import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import ECharts from 'vue-echarts'
import Util from '../../lib/util'

@Component({
    components:{ECharts}
})
export default class  extends Vue {
    @Prop({type:Object,default:{}}) options:any;
    data:any = {}
    mounted() {
        
        //生成数据
        let series = []
        console.log(this.options.data)
        let titles = []
        this.options.data.forEach((item,index) => {
            //计算百分比属性
            titles.push(Number((item.minValue/item.maxValue)*100).toFixed(0)+'%')
            series.push(
                {
                    type: 'pie',
                    radius: index==0?['60%', '70%']:['40%', '50%'],
                    hoverAnimation: false,
                    clockWise:false,
                    itemStyle: {
                        normal: {
                            label: {
                                show: false
                            },
                            labelLine: {
                                show: false
                            }
                        }
                    },
                    data: [{
                        value: item.minValue,
                        itemStyle: {
                            normal: {
                                color: { // 完成的圆环的颜色
                                    colorStops: [{
                                        offset: 0,
                                        color: index==0?'#00cefc':'#00CF68' // 0% 处的颜色
                                    }, {
                                        offset: 1,
                                        color: index==0?'#367bec':'#00CF68' // 100% 处的颜色
                                    }]
                                },
                                label: {
                                    show: false
                                },
                                labelLine: {
                                    show: false
                                }
                            } 
                        }
                    }, {
                        value: item.maxValue
                    }]
                }
            )
        });
        this.data =  {
            title: {
                text: `${titles[1]?titles[0]+'/'+titles[1]:titles[0]}`,
                x: 'center',
                y: 'center',
                textStyle: {
                    fontWeight: 'normal',
                    color: '#0580f2',
                    fontSize: titles[1]?'22':'42'
                }
            },
            color: ['rgba(176, 212, 251, 1)','#00CF68'], 
            series: series
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/charts/circleCharts.vue